import React, { FC, ReactNode } from 'react'

interface ItemProps {
  title: string
  content: string | ReactNode
  isOpen: boolean
  onChange: () => void
}

const AccordionItem: FC<ItemProps> = ({ title, content, isOpen, onChange }) => {
  return (
    <div className="accordion__item">
      <div
        className={`accordion__title ${isOpen ? '--open' : ''}`}
        onClick={onChange}
      >
        {title}
      </div>
      <div
        className={`accordion__collapse-box ${!isOpen ? '--collapsed' : ''}`}
      >
        <div className="accordion__content">
          {typeof content === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            content
          )}
        </div>
      </div>
    </div>
  )
}

export default AccordionItem
